import { useEffect } from "react";
import { useUIStore } from "../../../stores/UIStore";
import { Stack } from "@mantine/core";
import "@mantine/charts/styles.css";
import ReportingHeader from "./ReportingHeader";
import ReportingSummary from "./summary/ReportingSummary";
import ReportingActivity from "./activities/ReportingActivity";
import ReportingEmail from "./reportingEmail/ReportingEmail";
import ReportingLinkedin from "./reportingLinkedin/ReportingLinkedin";
import ReportingSenders from "./senders/ReportingSenders";
import ReportingLeads from "./leads/ReportingLeads";
import { getStatusCustom, getStatusSystem } from "../../../api/PRMAPI";
import ReportingSms from "./reportingSms/ReportingSms";

const Reporting = () => {
  useEffect(() => {
    useUIStore.getState().setHeaderClosed(true);
    getStatusCustom();
    getStatusSystem();
    return () => {
      useUIStore.getState().setHeaderClosed(false);
    };
  }, []);

  return (
    <Stack pos={"relative"}>
      <ReportingHeader />

      <Stack px={"xl"} mt={16} gap={"xl"}>
        <ReportingSummary />

        <ReportingActivity />

        <ReportingEmail />

        <ReportingLinkedin />

        <ReportingSms />

        <ReportingLeads />

        <ReportingSenders />
      </Stack>
    </Stack>
  );
};

export default Reporting;
